import { render } from "./DeleteAccountSucces.vue?vue&type=template&id=a95451c2"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__